// Vivid theme -warm cream + terracotta. Confident, with character.
// Mirrors the mockup's vividTheme exactly so colors and shapes stay in sync.

export type Locale = 'pt' | 'en';

export const theme = {
  c: {
    bg: '#F2EBDF',
    bgAlt: '#E9DFCD',
    surface: '#FFFCF5',
    surfaceAlt: '#F8F1E2',
    fg: '#1B1714',
    fgMuted: '#5E534A',
    fgFaint: '#9A8E80',
    border: 'rgba(27,23,20,0.12)',
    borderStrong: 'rgba(27,23,20,0.22)',
    accent: '#C8553D',
    accentDeep: '#A03F2A',
    accentFg: '#FFFCF5',
    accentSoft: '#F2C9BD',
    chip: 'rgba(200,85,61,0.10)',
    ink: '#1B1714',
    success: '#3F6B4A',
    danger: '#C8553D',
  },
  fonts: {
    display: 'var(--font-display), -apple-system, system-ui, sans-serif',
    body:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "Inter", system-ui, sans-serif',
    mono: 'var(--font-mono), ui-monospace, monospace',
    serif: 'var(--font-serif), Georgia, "Times New Roman", serif',
  },
  radii: { sm: 8, md: 14, lg: 20, xl: 28, pill: 999 },
} as const;

export type Theme = typeof theme;

// Slash-style section labels for the Vivid theme: "/ how it works"
export function sectionLabel(text: string): string {
  return `/ ${text.toLowerCase()}`;
}
